import { FgConfigurator } from '@/components';
import { Mode } from '@/types';
import { createContext } from '@lit/context';
import { LitElement } from 'lit';

export interface ConfiguratorContextType {
  /** The product identifier. */
  product: string;
  /** The color of the product (optional). */
  color?: string;
  /** The configuration ID (optional). */
  configurationId?: string;
  /** Indicates if the configuration is being edited. */
  editing: boolean;
  /** The mode of the configuration. */
  mode: Mode;
  /** The URL of the product image (optional). */
  productImage?: string;
  /** The name of the product (optional). */
  productName?: string;
  /** Indicates if the product is salable. */
  salable: boolean;
  /** The URL of the shop (optional). */
  shopUrl?: string;
  /** Unique selling points of the product (optional). */
  usps?: { text: string }[];
  /** The height of the sticky summary (optional). */
  stickySummaryHeight?: number;
  /** Indicates if the steps are valid. */
  hasValidSteps: boolean;
  /** Indicates if HSP is enabled (optional). */
  hspEnabled?: boolean;
}

export const configuratorGlobal = {
  context: createContext<ConfiguratorContextType>(
    Symbol('ConfiguratorContext'),
  ),
  resetContext: createContext<boolean>('ResetConfigurator'),
  /**
   *
   * @param component
   * @returns {ConfiguratorContextType}
   */
  init(component: FgConfigurator): ConfiguratorContextType {
    return {
      product: component.product,
      color: component.color,
      configurationId: component.configurationId,
      editing: component.editing,
      mode: component.mode,
      productImage: component.productImage,
      productName: component.productName,
      salable: component.salable,
      shopUrl: component.shopUrl,
      usps: component.usps,
      hasValidSteps: Object.values(component.validSteps).every(Boolean),
      stickySummaryHeight: component.stickySummaryHeight || 0,
      hspEnabled: false,
    };
  },
  updateGlobalProviderEvent(
    element: LitElement,
    data: ConfiguratorContextType,
  ) {
    element.dispatchEvent(
      new CustomEvent<{ context: ConfiguratorContextType }>(
        'configurator-context-update',
        {
          composed: true,
          detail: {
            context: data,
          },
        },
      ),
    );
  },
  updateResetProviderUpdate(element: LitElement, reset: boolean) {
    element.dispatchEvent(
      new CustomEvent<boolean>('configurator-reset-update', {
        composed: true,
        detail: reset,
      }),
    );
  },
};
